export default __webpack_public_path__ + "static/media/m-cart.8a9b88fe.svg";